/* ============================================================================
   B2B section behaviour - ticket T-2.
   Depends on b2b-pricing.js (generated from dark-dev/workers/pricing).

   It computes NOTHING about money itself: every figure on screen comes back from
   B2BPricing.resolve() or B2BPricing.nextRungOpportunity(). There is no percentage
   and no arithmetic on a price anywhere below.
   ============================================================================ */
(function () {
  'use strict';
  var P = window.B2BPricing;
  if (!P) return;

  var root = document.querySelector('[data-b2b-root]');
  if (!root) return;

  /* Version 1 sells the base build: thin lamination cards, the 48-page booklet, the standard
     box. The build selector that makes these three a buyer's choice is ticket T-41 and is not
     on this page; when it arrives it writes into this same object and nothing else changes. */
  var build = { finish: 'THIN_LAMINATION', box: 'STANDARD', booklet: true };

  var qty = {};        /* handle -> quantity            */
  var meta = {};       /* handle -> media + name + rule  */
  var cards = {};      /* handle -> card element         */

  document.querySelectorAll('[data-deck-media]').forEach(function (tag) {
    try { meta[tag.getAttribute('data-deck-media')] = JSON.parse(tag.textContent); } catch (e) {}
  });
  root.querySelectorAll('.b2b-card').forEach(function (c) { cards[c.getAttribute('data-deck')] = c; });

  var $ = function (sel, scope) { return (scope || root).querySelector(sel); };
  var summary = $('[data-role="summary"]');
  var bar = $('[data-role="bar"]');
  var sheet = $('[data-role="sheet"]');
  var scrim = $('[data-role="scrim"]');
  var announce = $('[data-role="announce"]');
  var openerCard = null;
  var sheetHandle = null;
  var lastRung = null;

  /* ---------------- state in the URL, so a hard reload survives ------------- */

  function readUrl() {
    var p = new URLSearchParams(location.search).get('b');
    if (!p) return;
    p.split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length === 2 && cards[bits[0]]) {
        var n = parseInt(bits[1], 10);
        if (n > 0) qty[bits[0]] = n;
      }
    });
  }

  function writeUrl() {
    var parts = Object.keys(qty).filter(function (h) { return qty[h] > 0; })
      .map(function (h) { return h + ':' + qty[h]; });
    var url = location.pathname + (parts.length ? '?b=' + parts.join(',') : '');
    history.replaceState(null, '', url);
    return parts.join(',');
  }

  /* ---------------- the two quantity rules, per line ----------------------- */

  function isInStock(handle) { return !!(meta[handle] && meta[handle].inStock); }

  /* T-3. `inStock` is a property of the TITLE; being able to ship fast is a property of the LINE.
     The fast ceiling is the largest rung our counted stock can fill (Liquid computes it from the
     cabinet count and never prints the count itself). Past that ceiling the deck is printed like
     any other, which means the press's own increment takes over on that line. */
  function ceilingFor(handle) {
    var m = meta[handle];
    return m && m.inStock && typeof m.fastCeiling === 'number' ? m.fastCeiling : 0;
  }
  function shipsFast(handle, quantity) {
    return isInStock(handle) && quantity > 0 && quantity <= ceilingFor(handle);
  }

  function step(handle, direction) {
    var cur = qty[handle] || 0;
    var fast = shipsFast(handle, cur);
    var next;
    if (direction > 0) {
      next = cur === 0 ? P.DATA.MINIMUM_ORDER_ITEMS
                       : cur + (fast ? 1 : P.DATA.QUANTITY_INCREMENT);
    } else {
      next = cur - (fast ? 1 : P.DATA.QUANTITY_INCREMENT);
      if (next < P.DATA.MINIMUM_ORDER_ITEMS) next = 0;
    }
    /* If the line lands past the ceiling it is a printed line, so it must sit on the printed
       grid: 12 to start, then in fours. Stepping up out of stock therefore goes 12 -> 16, not 13. */
    var message = null;
    if (next > 0 && !shipsFast(handle, next)) {
      var onGrid = P.snapQuantity(next, false);
      if (onGrid !== next) {
        message = 'Raised to ' + onGrid + ' — past ' + ceilingFor(handle) +
                  ' this deck is printed, and the press prints in multiples of ' +
                  P.DATA.QUANTITY_INCREMENT + '.';
        next = onGrid;
      }
    }
    setQty(handle, next, message);
  }

  /* Typing is free; the snap happens on blur, never on a keystroke, and it snaps UP. */
  function snapTyped(handle, raw) {
    var n = parseInt(String(raw).replace(/[^0-9]/g, ''), 10);
    if (!(n > 0)) return { value: 0, message: '' };
    var fast = shipsFast(handle, n);
    var snapped = P.snapQuantity(n, fast);
    var message = '';
    if (snapped !== n) {
      if (snapped === P.DATA.MINIMUM_ORDER_ITEMS && n < P.DATA.MINIMUM_ORDER_ITEMS) {
        message = 'Raised to ' + snapped + ' — our minimum order is ' + P.DATA.MINIMUM_ORDER_ITEMS + ' decks.';
      } else if (isInStock(handle)) {
        message = 'Rounded up to ' + snapped + ' — past ' + ceilingFor(handle) +
                  ' this deck is printed, and the press prints in multiples of ' + P.DATA.QUANTITY_INCREMENT + '.';
      } else {
        /* "the press", never "our press" - the printing house is a contractor, not ours
           (owner, 09.08: never describe the printing as our own facility). */
        message = 'Rounded up to ' + snapped + ' — the press prints in multiples of ' + P.DATA.QUANTITY_INCREMENT + '.';
      }
    }
    return { value: snapped, message: message };
  }

  function setQty(handle, value, message) {
    if (value > 0) qty[handle] = value; else delete qty[handle];
    var card = cards[handle];
    if (card) {
      var input = card.querySelector('[data-role="qty"]');
      if (input) input.value = value > 0 ? value : 0;
      card.setAttribute('data-selected', value > 0 ? 'true' : 'false');
      card.setAttribute('aria-selected', value > 0 ? 'true' : 'false');
      var down = card.querySelector('[data-step="down"]');
      if (down) down.disabled = !(value > 0);
      var snap = card.querySelector('[data-role="snap"]');
      if (snap) snap.textContent = message || '';
    }
    if (sheetHandle === handle) {
      var si = $('[data-role="qty"]', sheet);
      if (si) si.value = value > 0 ? value : 0;
      var ss = $('[data-role="snap"]', sheet);
      if (ss) ss.textContent = message || '';
    }
    render();
  }

  /* ---------------- rendering, all of it from the pricing module ----------- */

  function lines() {
    return Object.keys(qty).filter(function (h) { return qty[h] > 0; })
      .map(function (h) { return { deckId: h, quantity: qty[h], inStock: shipsFast(h, qty[h]) }; });
  }

  /* The e-mail hand-off, used while /pages/b2b-quote does not exist. It carries the build as data -
     deck, quantity, the resolved per-deck price and the goods total - plus the page URL that
     reproduces it, so nothing the buyer did is lost and nobody has to retype it. It states no price
     of its own: every figure comes back from P.resolve(), the same as the screen. */
  function mailtoFor(res, ls) {
    var email = root.getAttribute('data-trade-email') || '';
    var rows = ls.map(function (l) {
      var name = (meta[l.deckId] && meta[l.deckId].name) || l.deckId;
      return '- ' + name + ' x ' + l.quantity + (l.inStock ? ' (in stock)' : ' (printed to order)');
    }).join('\n');
    var body = 'My build:\n\n' + rows +
      '\n\n' + res.totalItems + ' decks at ' + P.usd(res.unitPriceMinor) + ' a deck' +
      '\nGoods total: ' + P.usd(res.goodsTotalMinor) +
      '\n\nMy delivery postcode and country: \nMy company: \n\n' +
      'Please send me the freight cost and the final total.\n\n' +
      'This build: ' + location.href + '\n';
    return 'mailto:' + email +
      '?subject=' + encodeURIComponent('Wholesale build - ' + res.totalItems + ' decks') +
      '&body=' + encodeURIComponent(body);
  }

  function render() {
    var ls = lines();
    var hasAny = ls.length > 0;
    var res = hasAny ? P.resolve({ finish: build.finish, box: build.box, booklet: build.booklet, lines: ls }) : null;

    var linesBox = $('[data-role="lines"]', summary);
    var totalWrap = $('[data-role="total-wrap"]', summary);
    var totalNote = $('[data-role="total-note"]', summary);
    var handoff = $('[data-role="handoff"]', summary);
    var handoffPhone = $('[data-role="handoff-phone"]', bar);

    /* The anchor: what a card says before the buyer has done anything, and again whenever he
       drops below the minimum. It is the 12-deck rung, resolved by the same function as every
       other figure on the page - never a constant, and identical to the Liquid-rendered anchor
       a crawler reads. Only the INITIAL state changed here; the figure still moves as he builds. */
    var anchor = P.resolve({
      finish: build.finish, box: build.box, booklet: build.booklet,
      lines: [{ deckId: '__anchor__', quantity: P.DATA.MINIMUM_ORDER_ITEMS }],
    });
    var top = P.DATA.RUNGS[P.DATA.RUNGS.length - 1];
    var anchorTop = P.resolve({
      finish: build.finish, box: build.box, booklet: build.booklet,
      lines: [{ deckId: '__anchor__', quantity: top }],
    });

    /* per-card price line, availability and quantity rule */
    Object.keys(cards).forEach(function (h) {
      var card = cards[h];
      var v = card.querySelector('[data-role="unit-value"]');
      var n = card.querySelector('[data-role="unit-note"]');
      var chosen = card.querySelector('[data-role="chosen"]');
      if (res && !res.belowMinimum) {
        if (v) v.textContent = P.usd(res.unitPriceMinor) + ' a deck';
        if (n) n.textContent = 'at ' + res.totalItems + ' decks in this order';
      } else {
        if (v) v.textContent = P.usd(anchor.unitPriceMinor) + ' a deck';
        if (n) n.textContent = 'at ' + P.DATA.MINIMUM_ORDER_ITEMS + ' decks, our minimum — ' +
                               P.usd(anchorTop.unitPriceMinor) + ' at ' + top;
      }
      if (chosen) chosen.textContent = qty[h] > 0 ? qty[h] + ' chosen' : '';

      /* T-3: the fast promise is bound to THIS line's quantity. Both wordings come from Liquid,
         which is the only place that knows the count; nothing about availability is composed here. */
      var m = meta[h] || {};
      var ceiling = ceilingFor(h);
      if (ceiling > 0) {
        var over = (qty[h] || 0) > ceiling;
        card.setAttribute('data-over-stock', over ? 'true' : 'false');
        var badge = card.querySelector('[data-role="avail-badge"]');
        if (badge) badge.textContent = over ? m.availabilityBeyond : m.availability;
        var rule = card.querySelector('[data-role="qty-rule"]');
        if (rule) rule.textContent = over ? m.quantityRuleBeyond : m.quantityRule;
        if (sheetHandle === h) {
          var sa = $('[data-role="sheet-availability"]', sheet);
          if (sa) sa.textContent = over ? m.availabilityBeyond : m.availability;
          var sr = $('[data-role="sheet-rule"]', sheet);
          if (sr) sr.textContent = over ? m.quantityRuleBeyond : m.quantityRule;
        }
      }
    });

    /* The lead time follows the build. All three wordings come from the markup - see the comment in
       b2b-build-summary.liquid. A mixed build takes the slower time and says why; an all-stock build
       gets to say 1-2 business days, which is the whole point of reading the warehouse. */
    var leadNote = $('[data-role="lead-note"]', summary);
    if (leadNote) {
      var fastCount = 0;
      for (var i = 0; i < ls.length; i++) if (ls[i].inStock) fastCount++;
      var which = 'slow';
      if (ls.length > 0) {
        if (fastCount === ls.length) which = 'fast';
        else if (fastCount > 0) which = 'mixed';
      }
      leadNote.textContent = leadNote.getAttribute('data-lead-' + which);
    }

    if (!hasAny) {
      linesBox.innerHTML = '<p class="b2b-summary__empty" data-role="empty">Nothing chosen yet. Pick a deck and a quantity.</p>';
      totalWrap.hidden = true; totalNote.hidden = true;
      $('[data-role="nudge"]', summary).innerHTML = '';
      handoff.disabled = true; handoffPhone.disabled = true;
      bar.setAttribute('data-active', 'false');
      root.classList.remove('b2b--has-bar');
      $('[data-role="bar-total"]', bar).textContent = '—';
      $('[data-role="bar-sub"]', bar).textContent = 'Nothing chosen yet';
      writeUrl();
      lastRung = null;
      return;
    }

    if (res.belowMinimum) {
      linesBox.innerHTML = '<p class="b2b-summary__empty">' + res.totalItems + ' decks — our minimum order is ' +
        res.minimum + '. Add ' + (res.minimum - res.totalItems) + ' more.</p>';
      totalWrap.hidden = true; totalNote.hidden = true;
      handoff.disabled = true; handoffPhone.disabled = true;
      $('[data-role="bar-total"]', bar).textContent = '—';
      $('[data-role="bar-sub"]', bar).textContent = res.totalItems + ' decks — minimum ' + res.minimum;
      bar.setAttribute('data-active', 'true');
      root.classList.add('b2b--has-bar');
      writeUrl();
      return;
    }

    var html = '';
    ls.forEach(function (l) {
      var name = (meta[l.deckId] && meta[l.deckId].name) || l.deckId;
      html += '<div class="b2b-summary__line"><span>' + escapeHtml(name) + '</span>' +
              '<b>' + l.quantity + ' &times; ' + P.usd(res.unitPriceMinor) + '</b></div>';
    });
    html += '<div class="b2b-summary__line"><span>' + res.totalItems + ' decks</span><b>' +
            P.usd(res.goodsTotalMinor) + '</b></div>';
    res.positions.forEach(function (p) {
      html += '<div class="b2b-summary__line"><span>' + escapeHtml(p.label) + '</span><b>' +
              P.usd(p.unitPriceMinor) + ' a deck</b></div>';
    });
    linesBox.innerHTML = html;

    totalWrap.hidden = false;
    $('[data-role="total"]', summary).textContent = P.usd(res.goodsTotalMinor);
    totalNote.hidden = false;
    totalNote.textContent = 'Goods only, before tax and shipping. ' + res.totalItems +
      ' decks at ' + P.usd(res.unitPriceMinor) + ' each.';

    handoff.disabled = false; handoffPhone.disabled = false;
    bar.setAttribute('data-active', 'true');
    root.classList.add('b2b--has-bar');
    $('[data-role="bar-total"]', bar).textContent = P.usd(res.goodsTotalMinor);
    $('[data-role="bar-sub"]', bar).textContent = res.totalItems + ' decks · without tax and shipping';

    renderNudge(res, ls);
    if (sheetHandle) renderSheetFooter(res);

    var handoffState = writeUrl();
    /* If the configurator page exists, hand the build to it. If it does not - and today it does
       not - the button must NOT navigate to a 404 and lose the whole build. It writes the build
       into an e-mail to the trade address instead, and says so. `data-quote-url` is resolved from
       the store's own page list by Liquid, so this repairs itself the day T-6 ships. */
    var quoteUrl = root.getAttribute('data-quote-url') || '';
    var target;
    if (quoteUrl) {
      target = quoteUrl + '?b=' + handoffState;
    } else {
      target = mailtoFor(res, ls);
    }
    handoff.setAttribute('data-handoff', target);
    handoffPhone.setAttribute('data-handoff', target);
    var liveQuote = !!quoteUrl;
    var labelKey = liveQuote ? 'data-label-live' : 'data-label-email';
    handoff.textContent = handoff.getAttribute(labelKey);
    handoffPhone.textContent = handoffPhone.getAttribute(labelKey);
    var hnote = $('[data-role="handoff-note"]', summary);
    if (hnote) hnote.hidden = liveQuote;

    /* A quantity change announces the TOTAL, never a delta - v2.1 section 8.
       A delta at the moment of a rung crossing reads as a penalty for buying more. */
    if (res.rung !== lastRung) {
      say(res.rung + '+ pricing — ' + P.usd(res.unitPriceMinor) + ' a deck, ' +
          P.usd(res.goodsTotalMinor) + ' for ' + res.totalItems + '.');
      lastRung = res.rung;
    } else {
      say(res.totalItems + ' decks, ' + P.usd(res.goodsTotalMinor) + ' before tax and shipping.');
    }
  }

  /* THE INVERSION. Never phrased by hand - every figure below is returned by the module. */
  function renderNudge(res, ls) {
    var box = $('[data-role="nudge"]', summary);
    var opp = P.nextRungOpportunity({ finish: build.finish, box: build.box, booklet: build.booklet, lines: ls });
    if (!opp) { box.innerHTML = ''; return; }

    if (opp.cheaperForMore) {
      box.innerHTML =
        '<div class="b2b-nudge"><b>' + opp.nextRung + ' decks cost you ' + P.usd(opp.savingMinor) +
        ' less than ' + res.totalItems + '.</b> ' + wordFor(opp.decksToAdd) +
        ' more decks, less money — ' + P.usd(opp.nextTotalMinor) + ' instead of ' +
        P.usd(opp.currentTotalMinor) + '.' + progress(res.totalItems, opp.nextRung) + '</div>';
    } else {
      box.innerHTML =
        '<div class="b2b-nudge">' + opp.decksToAdd + ' more decks and every deck costs ' +
        P.usd(opp.nextUnitPriceMinor) + '.' + progress(res.totalItems, opp.nextRung) + '</div>';
    }
  }

  function progress(now, target) {
    var pct = Math.max(0, Math.min(100, Math.round((now / target) * 100)));
    return '<div class="b2b-nudge__bar" role="presentation"><i style="width:' + pct + '%"></i></div>';
  }

  function wordFor(n) {
    var w = { 1: 'One', 2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five', 6: 'Six', 7: 'Seven', 8: 'Eight' };
    return w[n] || String(n);
  }

  function say(text) { if (announce) announce.textContent = text; }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- the drawer / bottom sheet ------------------------------ */

  function openSheet(handle, opener) {
    var m = meta[handle];
    if (!m) return;
    sheetHandle = handle;
    openerCard = opener;

    $('[data-role="sheet-title"]', sheet).textContent = m.name;
    $('[data-role="sheet-language"]', sheet).textContent = m.language;
    /* Both wordings are written by Liquid, which is the only place that knows the counted stock.
       Before T-3 this sentence was composed here in JavaScript from a boolean, which is how a
       page ends up with two versions of the same rule that drift apart. */
    var overNow = ceilingFor(handle) > 0 && (qty[handle] || 0) > ceilingFor(handle);
    $('[data-role="sheet-availability"]', sheet).textContent = overNow ? m.availabilityBeyond : m.availability;
    $('[data-role="sheet-rule"]', sheet).textContent = overNow ? m.quantityRuleBeyond : m.quantityRule;
    $('[data-role="qty"]', sheet).value = qty[handle] || 0;

    /* photographs are fetched here, not on the grid */
    var g = $('[data-role="sheet-gallery"]', sheet);
    var html = '';
    (m.video || []).forEach(function (src, i) {
      var poster = (m.videoPoster || [])[i] || '';
      html += '<div class="b2b-gallery__item"><video controls preload="none" playsinline poster="' +
              escapeHtml(poster) + '"><source src="' + escapeHtml(src) + '" type="video/mp4"></video></div>';
    });
    (m.gallery || []).forEach(function (src, i) {
      var alt = (m.galleryAlt || [])[i] || m.name;
      html += '<div class="b2b-gallery__item"><img src="' + escapeHtml(src) +
              '&width=1200" alt="' + escapeHtml(alt) + '" loading="lazy" decoding="async" width="1200" height="1500"></div>';
    });
    g.innerHTML = html;

    var count = (m.video || []).length + (m.gallery || []).length;
    var dots = '';
    for (var i = 0; i < count; i++) dots += '<i data-on="' + (i === 0) + '"></i>';
    $('[data-role="sheet-dots"]', sheet).innerHTML = dots;

    var bd = $('[data-role="sheet-breakdown"]', sheet);
    bd.innerHTML = summary.querySelector('[data-role="lines"]').innerHTML;

    scrim.hidden = false; sheet.hidden = false;
    requestAnimationFrame(function () {
      scrim.setAttribute('data-open', 'true');
      sheet.setAttribute('data-open', 'true');
    });
    if (opener) opener.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width: 1024px)').matches) document.body.style.overflow = 'hidden';
    $('[data-role="sheet-close"]', sheet).focus();
    document.addEventListener('keydown', onKeydown, true);
    render();
  }

  function closeSheet() {
    if (!sheetHandle) return;
    scrim.setAttribute('data-open', 'false');
    sheet.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown, true);
    if (openerCard) { openerCard.setAttribute('aria-expanded', 'false'); openerCard.focus(); }
    var was = sheetHandle;
    sheetHandle = null; openerCard = null;
    setTimeout(function () {
      if (!sheetHandle) { scrim.hidden = true; sheet.hidden = true; }
    }, 320);
    return was;
  }

  /* Escape closes, and focus is trapped while it is open. */
  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = sheet.querySelectorAll('a[href], button:not([disabled]), input, video, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderSheetFooter(res) {
    $('[data-role="sheet-total"]', sheet).textContent = P.usd(res.goodsTotalMinor);
    $('[data-role="sheet-sub"]', sheet).textContent = res.totalItems + ' decks · without tax and shipping';
  }

  /* ---------------- wiring -------------------------------------------------- */

  root.addEventListener('click', function (e) {
    var card = e.target.closest('.b2b-card');
    var stepBtn = e.target.closest('[data-step]');
    if (stepBtn && card) { step(card.getAttribute('data-deck'), stepBtn.getAttribute('data-step') === 'up' ? 1 : -1); return; }
    var open = e.target.closest('[data-role="open-sheet"]');
    if (open && card) { openSheet(card.getAttribute('data-deck'), open); return; }
    var go = e.target.closest('[data-role="handoff"], [data-role="handoff-phone"]');
    if (go && !go.disabled) { location.href = go.getAttribute('data-handoff') || '#'; }
  });

  root.addEventListener('blur', function (e) {
    var input = e.target.closest ? e.target.closest('[data-role="qty"]') : null;
    if (!input) return;
    var card = e.target.closest('.b2b-card');
    if (!card) return;
    var h = card.getAttribute('data-deck');
    var r = snapTyped(h, input.value);
    setQty(h, r.value, r.message);
  }, true);

  sheet.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-step]');
    if (stepBtn && sheetHandle) { step(sheetHandle, stepBtn.getAttribute('data-step') === 'up' ? 1 : -1); return; }
    if (e.target.closest('[data-role="sheet-close"]') || e.target.closest('[data-role="sheet-done"]')) closeSheet();
  });

  sheet.addEventListener('blur', function (e) {
    var input = e.target.closest ? e.target.closest('[data-role="qty"]') : null;
    if (!input || !sheetHandle) return;
    var r = snapTyped(sheetHandle, input.value);
    setQty(sheetHandle, r.value, r.message);
  }, true);

  var gallery = $('[data-role="sheet-gallery"]', sheet);
  gallery.addEventListener('scroll', function () {
    var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
    $('[data-role="sheet-dots"]', sheet).querySelectorAll('i').forEach(function (dot, n) {
      dot.setAttribute('data-on', String(n === i));
    });
  }, { passive: true });

  scrim.addEventListener('click', closeSheet);

  /* drag the sheet down past a quarter of its height to close it, on a phone */
  var dragFrom = null;
  sheet.addEventListener('touchstart', function (e) { dragFrom = e.touches[0].clientY; }, { passive: true });
  sheet.addEventListener('touchend', function (e) {
    if (dragFrom === null) return;
    var dy = e.changedTouches[0].clientY - dragFrom;
    if (dy > sheet.getBoundingClientRect().height * 0.25) closeSheet();
    dragFrom = null;
  }, { passive: true });

  readUrl();
  Object.keys(qty).forEach(function (h) { setQty(h, qty[h], null); });
  render();
}());
